
/**
 * 검색어 (제목, 설명에서 검색)
 */
export type QueryParam2Parameter = string;
